"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContact = createContact;
exports.deleteContact = deleteContact;
exports.gdprDeleteContact = gdprDeleteContact;
exports.fetchByEmail = fetchByEmail;
exports.refresh = refresh;
exports.updateContactProperties = updateContactProperties;
exports.updateContacts = updateContacts;
exports.promoteEmailToPrimary = promoteEmailToPrimary;
exports.addSecondaryEmail = addSecondaryEmail;
exports.updateSecondaryEmail = updateSecondaryEmail;
exports.deleteSecondaryEmail = deleteSecondaryEmail;
exports.removeEmail = removeEmail;
exports.onPipelineChange = onPipelineChange;

var _immutable = require("immutable");

var _isFunction = _interopRequireDefault(require("transmute/isFunction"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _ContactRecord = _interopRequireDefault(require("customer-data-objects/contact/ContactRecord"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var ContactsAPI = _interopRequireWildcard(require("crm_data/contacts/api/ContactsAPI"));

var GdprDeleteAPI = _interopRequireWildcard(require("crm_data/contacts/api/GdprDeleteAPI"));

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _transact = require("crm_data/flux/transact");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _AssociationTypes = require("crm_data/associations/AssociationTypes");

var _ObjectsActions = _interopRequireDefault(require("crm_data/objects/ObjectsActions"));

var getCreateContactPayload = function getCreateContactPayload(record) {
  return record.get('properties').reduce(function (list, _ref, property) {
    var value = _ref.value,
        source = _ref.source,
        sourceId = _ref.sourceId;
    return list.push({
      value: value,
      property: property,
      'source-id': sourceId,
      source: source
    });
  }, (0, _immutable.List)());
};

var makeAssociationKey = function makeAssociationKey(id, associationType) {
  return (0, _immutable.Map)({
    objectId: id,
    objectType: _ObjectTypes.CONTACT,
    associationType: associationType
  });
};

function createContact(record) {
  var payload = getCreateContactPayload(record);
  return ContactsAPI.createContact(payload).then(function (response) {
    var contact = response.first();
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACT_CREATED, contact);
    return contact;
  });
}

function deleteContact(vid, callback) {
  return ContactsAPI.deleteContact(vid).then(function () {
    setTimeout(function () {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACTS_UPDATED, (0, _immutable.Map)().set("" + vid, null));
    }, 0);
    return typeof callback === 'function' ? callback() : undefined;
  }).done();
}

function gdprDeleteContact(vid, email, callback) {
  return GdprDeleteAPI.deleteContact([vid], email).then(function () {
    setTimeout(function () {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACTS_UPDATED, (0, _immutable.Map)().set("" + vid, null));
    }, 0);
    return typeof callback === 'function' ? callback() : undefined;
  }).done();
}

function fetchByEmail(email) {
  return ContactsAPI.fetchByEmail(email).then(function (contacts) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACTS_FETCH_SUCCEEDED, contacts);
    return contacts;
  });
}

function refresh(contactIds) {
  (0, _Dispatch.dispatchQueue)(_ActionTypes.CONTACTS_REFRESH_QUEUED, (0, _immutable.Set)(contactIds));
  (0, _Dispatch.dispatchQueue)(_ActionTypes.ASSOCIATIONS_REFRESH_QUEUED, (0, _immutable.Set)([makeAssociationKey(contactIds[0], _AssociationTypes.CONTACT_TO_COMPANY), makeAssociationKey(contactIds[0], _AssociationTypes.CONTACT_TO_DEAL), makeAssociationKey(contactIds[0], _AssociationTypes.CONTACT_TO_TICKET)]));
}

function updateContactProperties(contact, nextProperties, errorHandler) {
  var id = "" + (0, _ImmutableModel.getId)(contact);
  var properties = nextProperties.map(function (_, name) {
    return (0, _ImmutableModel.getProperty)(contact, name);
  });
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACTS_UPDATE_STARTED, {
    id: id,
    properties: properties,
    nextProperties: nextProperties
  });
  return ContactsAPI.updateContactProperties(contact, nextProperties).then(function () {
    return (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACTS_UPDATE_SUCCEEDED, {
      id: id,
      properties: nextProperties,
      prevProperties: properties
    });
  }, function (error) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACTS_UPDATE_FAILED, {
      id: id,
      properties: properties,
      nextProperties: nextProperties,
      error: error
    });

    if ((0, _isFunction.default)(errorHandler)) {
      errorHandler(nextProperties, error);
    }

    throw error;
  });
}

function updateContacts(contacts) {
  (0, _invariant.default)(_immutable.Map.isMap(contacts), 'ContactsActions: expected contacts to be a Map but got "%s"');
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACTS_UPDATED, contacts);
}

function promoteEmailToPrimary(contact, promotedEmail) {
  var vid = "" + (0, _ImmutableModel.getId)(contact);
  var demotedEmail = (0, _ImmutableModel.getProperty)(contact, 'email');
  var additionalEmails = (0, _ImmutableModel.getProperty)(contact, 'hs_additional_emails');
  var nextAdditionalEmails = (0, _ImmutableModel.getProperty)(contact, 'hs_additional_emails').split(';');
  var promotedEmailIndex = nextAdditionalEmails.indexOf(promotedEmail);
  nextAdditionalEmails.slice(promotedEmailIndex, 1);
  nextAdditionalEmails.push(demotedEmail);
  return (0, _transact.transact)({
    operation: function operation() {
      return ContactsAPI.promoteEmailToPrimary(vid, promotedEmail);
    },
    commit: [_ActionTypes.CONTACT_SECONDARY_EMAIL_PROMOTED, {
      vid: vid,
      promotedEmail: promotedEmail,
      additionalEmails: nextAdditionalEmails.join(';')
    }],
    rollback: [_ActionTypes.CONTACT_SECONDARY_EMAIL_PROMOTED, {
      vid: vid,
      additionalEmails: additionalEmails,
      promotedEmail: promotedEmail
    }]
  });
}

function addSecondaryEmail(contact, email) {
  (0, _invariant.default)(contact instanceof _ContactRecord.default, 'ContactsActions: expected contact to be a ContactRecord but got "%s"');
  (0, _invariant.default)(typeof email === 'string', 'ContactsActions: expected email to be a string but got "%s"');
  var vid = "" + (0, _ImmutableModel.getId)(contact);
  return (0, _transact.transact)({
    operation: function operation() {
      return ContactsAPI.addSecondaryEmail(vid, email);
    },
    commit: [_ActionTypes.CONTACT_SECONDARY_EMAIL_ADDED, {
      vid: vid,
      email: email
    }],
    rollback: [_ActionTypes.CONTACT_SECONDARY_EMAIL_REMOVED, {
      vid: vid,
      email: email
    }]
  });
}

function updateSecondaryEmail(contact, prevEmail, nextEmail) {
  (0, _invariant.default)(contact instanceof _ContactRecord.default, 'ContactsActions: expected contact to be a ContactRecord but got "%s"');
  (0, _invariant.default)(typeof nextEmail === 'string', 'ContactsActions: expected nextEmail to be a string but got "%s"');
  (0, _invariant.default)(typeof prevEmail === 'string', 'ContactsActions: expected prevEmail to be a string but got "%s"');
  var vid = "" + (0, _ImmutableModel.getId)(contact);
  return (0, _transact.transact)({
    operation: function operation() {
      return ContactsAPI.updateSecondaryEmail(vid, prevEmail, nextEmail);
    },
    commit: [_ActionTypes.CONTACT_SECONDARY_EMAIL_UPDATED, {
      vid: vid,
      prevEmail: prevEmail,
      nextEmail: nextEmail
    }],
    rollback: [_ActionTypes.CONTACT_SECONDARY_EMAIL_UPDATED, {
      vid: vid,
      prevEmail: nextEmail,
      nextEmail: prevEmail
    }]
  });
}

function deleteSecondaryEmail(contact, email) {
  (0, _invariant.default)(contact instanceof _ContactRecord.default, 'ContactsActions: expected contact to be a ContactRecord but got "%s"');
  (0, _invariant.default)(typeof email === 'string', 'ContactsActions: expected email to be a string but got "%s"');
  var vid = "" + (0, _ImmutableModel.getId)(contact);
  return (0, _transact.transact)({
    operation: function operation() {
      return ContactsAPI.deleteSecondaryEmail(vid, email);
    },
    commit: [_ActionTypes.CONTACT_SECONDARY_EMAIL_REMOVED, {
      vid: vid,
      email: email
    }],
    rollback: [_ActionTypes.CONTACT_SECONDARY_EMAIL_ADDED, {
      vid: vid,
      email: email
    }]
  });
}

function removeEmail(contact, email) {
  var vid = "" + (0, _ImmutableModel.getId)(contact);
  return ContactsAPI.removeEmail(vid, email).then(function () {
    return (0, _Dispatch.dispatchImmediate)(_ActionTypes.CONTACT_EMAIL_REMOVED, {
      vid: vid,
      email: email
    });
  });
}

function onPipelineChange(subject, updates, onError) {
  _ObjectsActions.default.updateStores(subject, updates, {
    onError: onError
  });
}